import React from "react";
import { Link } from "gatsby";

import AbstractFooter from "./AbstractFooter";

const FooterLink = ({ children, to }) => (
    <Link
        to={ to }
        css={{
            padding: 5,
            ":hover": {
                color: "var(--green)",
            },
        }}
    >
        { children }
    </Link>
);

export default () => (
    <AbstractFooter>
        <div css={{
            marginBottom: 10,
            color: "darkgrey",
            fontSize: ".9em",
        }}>
            <FooterLink to="/terms">Terms</FooterLink>
            <FooterLink to="/privacy">Privacy</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
        </div>
        <div css={{
            fontSize: ".8em",
        }}>
            Copyright &copy; 2020&nbsp;-&nbsp;<a href="https://traction.one" target="_blank" rel="noreferrer">Sankarsan Kampa</a>
        </div>
    </AbstractFooter>
);
